import { render, staticRenderFns } from "./navigation-footer.vue?vue&type=template&id=3abd5657&"
import script from "./navigation-footer.vue?vue&type=script&lang=ts&"
export * from "./navigation-footer.vue?vue&type=script&lang=ts&"
import style0 from "./navigation-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports